// Configuración canónica del cotizador compartida por todos los cotizadores
// (Menu Cotizar, Carga Manual IA, Landing Page). Cualquier cambio aquí se
// aplica automáticamente a todos los cotizadores que la importan.

import { AGGREGATOR_META } from "@/lib/aggregatorMeta";

// Leyenda de convenios/agregadores mostrada como filtros rápidos en los
// resultados de cotización.
//
// REGLA: el filtro incluye TODOS los agregadores soportados por la plataforma
// que puedan contar con credenciales/llaves/tokens (el catálogo completo de
// AGGREGATOR_META). Cada chip se etiqueta con el NOMBRE INTERNO del agregador
// (AGGREGATOR_META[key].internalName), no con la marca externa. Así ningún
// agregador configurado queda fuera del selector (ej. enviot2/T1Envios).
//
// `sources` agrupa los source que representa cada chip:
//   - "bhgc" agrupa los sources internos "interno" y "bhgc" (tarifas propias).
//   - "mydhl" agrupa el source "mydhl" (DHL MyDHL API, convenio SGM).
//   - los demás agregadores mapean 1:1 su clave interna → source.
// Un chip sólo se activa cuando existen tarifas con ese source (presentSources);
// los agregadores sin credenciales/tarifas quedan en gris (cursor not-allowed).
const DOT_COLORS = {
  bhgc: "bg-cyan",
  directo: "bg-slate-400",
  mydhl: "bg-amber-500",
  envia: "bg-success",
  pak2go: "bg-warning",
  interpack: "bg-indigo-400",
  skypractico: "bg-fuchsia-400",
  srsimi: "bg-rose-400",
  elogicya: "bg-sky-400",
  enviot2: "bg-teal-400",
  sigomx: "bg-violet-400",
  shipwoo: "bg-lime-500",
  genienvios: "bg-emerald-400",
  multipaq: "bg-orange-400",
  slenvios: "bg-pink-400",
  enviocohete: "bg-amber-400",
  aftership: "bg-rose-400"
};

// Orden de aparición de los chips en el filtro de convenios.
const LEGEND_ORDER = [
  "bhgc", "directo", "mydhl", "envia", "pak2go", "interpack", "skypractico",
  "srsimi", "elogicya", "sigomx", "enviot2", "shipwoo", "genienvios",
  "multipaq", "slenvios", "enviocohete", "aftership"
];

// Mapeo de la clave interna → sources que agrupa el chip.
const SOURCES_BY_KEY = {
  bhgc: ["bhgc"],
  directo: ["interno"],
  mydhl: ["mydhl"]
};

// Etiqueta (nombre interno/marca) mostrada en cada chip. Coincide con el
// `name` del catálogo de Conexiones (INTEGRATION_CATALOG) para los agregadores
// que ahí figuran; los restantes (bhgc, mydhl, slenvios) usan su marca corta.
const LABEL_BY_KEY = {
  bhgc: "BHGC Nexus",
  directo: "Convenio directo",
  mydhl: "SGM",
  envia: "Tendencys",
  pak2go: "Epak",
  interpack: "Interpack",
  skypractico: "SkyPractico",
  srsimi: "SrSimi",
  elogicya: "ELogicYa",
  sigomx: "SigoMx",
  enviot2: "EnvioT2",
  shipwoo: "ShipWoo",
  genienvios: "GeniEnvios",
  multipaq: "MultiPaq",
  slenvios: "SLEnvios",
  enviocohete: "Turbo Envíos",
  aftership: "AfterShip"
};

function buildSourceLegend() {
  const legend = [];
  for (const key of LEGEND_ORDER) {
    // "directo" (convenios directos DHL/FedEx/UPS/J&T) no es un agregador del
    // catálogo, pero sí un grupo de tarifas propio distinto de BHGC.
    const meta = AGGREGATOR_META[key] || (key === "directo" ? { internalName: "directo" } : null);
    if (!meta) continue;
    legend.push({
      key,
      label: LABEL_BY_KEY[key] || meta.internalName,
      dot: DOT_COLORS[key] || "bg-ink-muted",
      sources: SOURCES_BY_KEY[key] || [key]
    });
  }
  return legend;
}

export const SOURCE_LEGEND = buildSourceLegend();